import { Document, Page, Text, View, StyleSheet} from '@react-pdf/renderer';

import { Font } from '@react-pdf/renderer';



const styles = StyleSheet.create({
        page: {
            padding: 10, // Reduce padding
      
            fontSize: 10,
            marginLeft: 40,
            marginRight: 40,
            marginTop: 10,
            marginBottom: 10,
            lineHeight: 1.5,

          },
          solidLine: {
           
            borderBottomWidth: 1,   // thickness of the line
            borderBottomColor: '#000', // color (black here)
            width: '100%',         // full width of page or container
          },
          
          title: {
            fontSize: 14, 
            marginBottom: 10, 
            textAlign: 'center',
            fontWeight: 'bold', 
          },
          subhead: {
            fontSize: 10,
            textAlign: 'center',
          },
          paragraph: {
            fontSize: 10,
            marginBottom: 5, 
            textAlign: 'justify',
          },


  // Main table styles
  table: {
    display: 'table',
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
  },
  row: {
    flexDirection: 'row',
    borderBottom: '1px solid #000',
  },
  cell: {
    padding: 5,
    borderRight: '1px solid #000',
    verticalAlign: 'middle',
  },
  srNoCell: {
    width: '5%',
  },
  detailsCell: {
    width: '55%',
  },
  pageNoCell: {
    width: '40%',
  },
  // Special merged cell for row 18
  mergedCell: {
    padding: 5,
    width: '95%', // 55% + 40%
    borderRight: 'none', // Remove right border
  },

  // Nested table styles
  nestedTable: {
    display: 'table',
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
    borderCollapse: 'collapse',
    marginTop: 5,
    marginBottom: 5,
  },
  nestedRow: {
    flexDirection: 'row',
  },
  nestedHeaderCell: {
    fontWeight: 'bold',
    backgroundColor: '#f2f2f2',
    padding: 3,
    textAlign: 'center',
    borderRight: '1px solid #000',
    borderBottom: '1px solid #000',
    fontSize: 8,
  },
  nestedCell: {
    padding: 3,
    borderRight: '1px solid #000',
    borderBottom: '1px solid #000',
    textAlign: 'center',
    fontSize: 8,
  },
  // Equal width for all 6 columns
  // nestedCol: {
  //   width: '16.66%',
  // },
  nestedCol1: { width: '20%' },   // Month column - wider
  nestedCol2: { width: '18%' },   // Basic Pay
  nestedCol3: { width: '15%' },   // Grade Pay
  nestedCol4: { width: '15%' },   // DA
  nestedCol5: { width: '12%' },   // Other
  nestedCol6: { width: '20%' },   // Total - wider


        });

      
        
        
        const Form6Part1P2 = ({ result }) => {
       
          // Safely access properties with try-catch to prevent runtime errors
          const getTableData = () => {
            try {
              return [
                ['14', 
                  'Details of commissions, imperfections or deficiencies in the service book which have been ignored under rule 121 of the Maharashtra Civil Services (Pension) Rule 1982.', 
                  'NIL'
                ],
                ['15', 
                  'Total length of qualifying service (for purpose of adding towards broken periods, a month is reckoned as thirty days.)',
                  `${result.calculation && result.calculation[0] && result.calculation[0].pensionableService ? 
                    `${result.calculation[0].pensionableService.years || 0} Years ${result.calculation[0].pensionableService.months || 0} Months ${result.calculation[0].pensionableService.days || 0} Days` : 
                    '0 Years 0 Months 0 Days'
                  }`
                ],
                ['16', `Periods of non-qualifying service
                  i) Interruption in service condoned under Rule 48 of the MCS (Pension) Rules, 1982
                  ii) Extraordinary leave not qualifying for pension
                  iii) Period of suspension not treated as qualifying service
                  iv) Other non-qualifying service`,
                  `${result.nonQualifyServiceYears || 0} Years ${result.nonQualifyServiceMonths || 0} Months ${result.nonQualifyServiceDays || 0} Days`
                ],
                ['17',
                  'Pay reckoned for gratuity Pay Rs.',
                  result.basicPay || 0
                ],
                ['18', 
                  (
                    <View style={{ flexDirection: 'column' }}>
                      <Text>Average pensionable pay. Pay earned during the last ten months of service.</Text>
                      
                      {/* Nested Table Container - spans columns 2+3 */}
                      <View style={styles.nestedTable}>
                        {/* Header Row */}
                        <View style={styles.nestedRow}>
                          <Text style={[styles.nestedHeaderCell, styles.nestedCol1]}>Post Held</Text>
                          <Text style={[styles.nestedHeaderCell, styles.nestedCol2]}>From</Text>
                          <Text style={[styles.nestedHeaderCell, styles.nestedCol3]}>To</Text>
                          <Text style={[styles.nestedHeaderCell, styles.nestedCol4]}>No of Months</Text>
                          <Text style={[styles.nestedHeaderCell, styles.nestedCol5]}>Rate of Pay </Text>
                          <Text style={[styles.nestedHeaderCell, styles.nestedCol6]}>Amount</Text>
                        </View>
                        
                        {/* Data Rows */}
                        <View style={styles.nestedRow}>
                          <Text style={[styles.nestedCell, styles.nestedCol1]}>{result.designation} </Text>
                          <Text style={[styles.nestedCell, styles.nestedCol2]}>{result.payrateTable && result.payrateTable[0] ? result.payrateTable[0].from : '--'}</Text>
                          <Text style={[styles.nestedCell, styles.nestedCol3]}>{result.payrateTable && result.payrateTable[0] ? result.payrateTable[0].to : '--'}</Text>
                          <Text style={[styles.nestedCell, styles.nestedCol4]}>
                            {result.calculation && result.calculation[0] && result.calculation[0].PensionablePayAvg && result.calculation[0].PensionablePayAvg.period1 ? 
                              `${result.calculation[0].PensionablePayAvg.period1.months || 0} M ${(result.calculation[0].PensionablePayAvg.period1.Dfirst || 0) + (result.calculation[0].PensionablePayAvg.period1.Dsecond || 0)} D` : 
                              '--'
                            }
                          </Text>
                          <Text style={[styles.nestedCell, styles.nestedCol5]}>{result.payrateTable && result.payrateTable[0] ? result.payrateTable[0].payrate : 0}</Text>
                          <Text style={[styles.nestedCell, styles.nestedCol6]}>
                            {result.calculation && result.calculation[0] && result.calculation[0].PensionablePayAvg ? 
                              result.calculation[0].PensionablePayAvg.total1 || 0 : 
                              0
                            }
                          </Text>
                        </View>
                        
                        <View style={styles.nestedRow}>
                          <Text style={[styles.nestedCell, styles.nestedCol1]}></Text>
                          <Text style={[styles.nestedCell, styles.nestedCol2]}>{result.payrateTable && result.payrateTable[1] ? result.payrateTable[1].from : '--'}</Text>
                          <Text style={[styles.nestedCell, styles.nestedCol3]}>{result.payrateTable && result.payrateTable[1] ? result.payrateTable[1].to : '--'}</Text>
                          <Text style={[styles.nestedCell, styles.nestedCol4]}>
                            {result.calculation && result.calculation[0] && result.calculation[0].PensionablePayAvg && result.calculation[0].PensionablePayAvg.period2 ? 
                              `${result.calculation[0].PensionablePayAvg.period2.months || 0} M ${(result.calculation[0].PensionablePayAvg.period2.Dfirst || 0) + (result.calculation[0].PensionablePayAvg.period2.Dsecond || 0)} D` : 
                              '--'
                            }
                          </Text>
                          <Text style={[styles.nestedCell, styles.nestedCol5]}>{result.payrateTable && result.payrateTable[1] ? result.payrateTable[1].payrate : 0}</Text>
                          <Text style={[styles.nestedCell, styles.nestedCol6]}>
                            {result.calculation && result.calculation[0] && result.calculation[0].PensionablePayAvg ? 
                              result.calculation[0].PensionablePayAvg.total2 || 0 : 
                              0
                            }
                          </Text>
                        </View>
                        
                        <View style={styles.nestedRow}>
                          <Text style={[styles.nestedCell, styles.nestedCol1]}></Text>
                          <Text style={[styles.nestedCell, styles.nestedCol2]}>--</Text>
                          <Text style={[styles.nestedCell, styles.nestedCol3]}>--</Text>
                          <Text style={[styles.nestedCell, styles.nestedCol4]}>10 Months</Text>
                          <Text style={[styles.nestedCell, styles.nestedCol5]}>
                            {(result.payrateTable && result.payrateTable[0] ? result.payrateTable[0].payrate : 0) + 
                             (result.payrateTable && result.payrateTable[1] ? result.payrateTable[1].payrate : 0)}
                          </Text>
                          <Text style={[styles.nestedCell, styles.nestedCol6]}>
                            {result.calculation && result.calculation[0] && result.calculation[0].PensionablePayAvg ? 
                              result.calculation[0].PensionablePayAvg.netTotal || 0 : 
                              0
                            }
                          </Text>
                        </View>
                      </View>
            
                      <Text>Average pay for the last ten months of service (A) - {
                        result.calculation && result.calculation[0] && result.calculation[0].PensionablePayAvg ? 
                          (result.calculation[0].PensionablePayAvg.netTotal || 0) / 10 : 
                          0
                      }, Last Months Basic Pay (B) - {result.basicPay || 0} </Text>
                      <Text>Notional Pay (c) - {result.notionalPay || 0}</Text>
                      <Text>Pensionable Pay (Max of A & B & C)                        -  {result.pensionablePay || 0}</Text>
                      <View style={{ fontSize: 8 }} >
                        <Text>Note:</Text>
                        <Text>i) In a case where the last months include some period not to be reckoned for calculating average pay an equal period backward has to be taken for calculating average pay.</Text>
                        <Text>ii) The calculation of average pay should be based on actual number of days contained in each month.</Text>
                      </View>
                    </View>
                  ),
                ],
                ['19', 
                  'Date on which Form 5 has been obtained from the Government servant (To be obtained eight months before the date of retirement of Government servant.) ',
                  ''
                ],
                ['20', 
                 `i)	Proposed Pension.
                 ii)	Proposed relief on Pension`,
                 `${Math.round((result.pension || 0))} 
                As per Govt. Rule.`
                ],
                ['21', 
                  'Proposed death Cum retirement gratuity',
                  `${result.calculation && result.calculation[0] && result.calculation[0].terms ? 
                    (result.calculation[0].terms) * (result.basicPay || 0) / 4 : 
                    0
                  }`
                ],
                ['22', 
                  'Date from which pension is to commerce',
                  result?.dateOfRetirement
                  ? (() => {
                      const [d, m, y] = result.dateOfRetirement.split('/').map(Number);
                      const date = new Date(y, m - 1, d);
                      date.setDate(date.getDate() + 1);
                      return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
                    })()
                  : 'N/A'
               ],
                ['23', 
                  'Proposed amount of provisional pension (if departmental or judicial proceedings is instituted against the Government servant before retirement.)',
                  'NIL'
                ],
                ['24',
                  `Details of Government dues recoverable out of gratuity and Head of Account to which they are to be credited
                   i)	Licence for the allotment of Government accommodation (See rule (2),(3) and (4) of rule 133 of Maharashtra Services (pension) Rules 1982.
                   ii)	Dues referred to in rule 134 of Maharashtra Civil Services (Pension) Rules 1982.`,
                   `
                   
                   i) NIL
                  
                  
                   ii) NIL`
                ]
              ];
            } catch (error) {
              console.error("Error in Form6Part1P2:", error);
              // Return a minimal table with error information
              return [
                ['Error', 'An error occurred while generating this form.', 'Please check the data provided.']
              ];
            }
          };

          const tableData = getTableData();
        
          return (
            <View size="A4" style={styles.page}> 
              <View style={styles.table}>
                {tableData.map(([srNo, details, value], index) => (
                  <View style={styles.row} key={index}>
                    <Text style={[styles.cell, styles.srNoCell]}>{srNo}</Text>
                    
                    {srNo === '18' ? (
                      <View style={styles.mergedCell}>
                        {details}
                      </View>
                    ) : (
                      <>
                        <Text style={[styles.cell, styles.detailsCell]}>{details}</Text>
                        <Text style={[styles.cell, styles.pageNoCell]}>{value}</Text>
                      </>
                    )}
                  </View>
                ))}
              </View>
            </View>
          );
        };
        
        export default Form6Part1P2;